import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { initSentry } from '@trader/services';
import { rootStore, RootStoreProvider } from '@trader/store';
import { useAppVersion, useInternetStatus } from '@trader/hooks';

import { App } from './app';

export const AppContainer: React.FC = () => {
  initSentry();

  useAppVersion();
  useInternetStatus();

  return (
    <BrowserRouter>
      <RootStoreProvider value={rootStore}>
        <App />
      </RootStoreProvider>
    </BrowserRouter>
  );
};
